"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ClaimResponse = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_ClaimResponse_Item_1 = require("./RTTI_ClaimResponse_Item");
var RTTI_ClaimResponse_AddItem_1 = require("./RTTI_ClaimResponse_AddItem");
var RTTI_ClaimResponse_Adjudication_1 = require("./RTTI_ClaimResponse_Adjudication");
var RTTI_ClaimResponse_Total_1 = require("./RTTI_ClaimResponse_Total");
var RTTI_ClaimResponse_Payment_1 = require("./RTTI_ClaimResponse_Payment");
var RTTI_Attachment_1 = require("./RTTI_Attachment");
var RTTI_ClaimResponse_ProcessNote_1 = require("./RTTI_ClaimResponse_ProcessNote");
var RTTI_ClaimResponse_Insurance_1 = require("./RTTI_ClaimResponse_Insurance");
var RTTI_ClaimResponse_Error_1 = require("./RTTI_ClaimResponse_Error");
exports.RTTI_ClaimResponse = t.recursion('IClaimResponse', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('ClaimResponse'),
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            patient: RTTI_Reference_1.RTTI_Reference,
            insurer: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            subType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            use: RTTI_code_1.RTTI_code,
            _use: RTTI_Element_1.RTTI_Element,
            created: RTTI_dateTime_1.RTTI_dateTime,
            _created: RTTI_Element_1.RTTI_Element,
            requestor: RTTI_Reference_1.RTTI_Reference,
            request: RTTI_Reference_1.RTTI_Reference,
            outcome: RTTI_code_1.RTTI_code,
            _outcome: RTTI_Element_1.RTTI_Element,
            disposition: t.string,
            _disposition: RTTI_Element_1.RTTI_Element,
            preAuthRef: t.string,
            _preAuthRef: RTTI_Element_1.RTTI_Element,
            preAuthPeriod: RTTI_Period_1.RTTI_Period,
            payeeType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            item: t.array(RTTI_ClaimResponse_Item_1.RTTI_ClaimResponse_Item),
            addItem: t.array(RTTI_ClaimResponse_AddItem_1.RTTI_ClaimResponse_AddItem),
            adjudication: t.array(RTTI_ClaimResponse_Adjudication_1.RTTI_ClaimResponse_Adjudication),
            total: t.array(RTTI_ClaimResponse_Total_1.RTTI_ClaimResponse_Total),
            payment: RTTI_ClaimResponse_Payment_1.RTTI_ClaimResponse_Payment,
            fundsReserve: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            formCode: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            form: RTTI_Attachment_1.RTTI_Attachment,
            processNote: t.array(RTTI_ClaimResponse_ProcessNote_1.RTTI_ClaimResponse_ProcessNote),
            communicationRequest: t.array(RTTI_Reference_1.RTTI_Reference),
            insurance: t.array(RTTI_ClaimResponse_Insurance_1.RTTI_ClaimResponse_Insurance),
            error: t.array(RTTI_ClaimResponse_Error_1.RTTI_ClaimResponse_Error)
        })
    ]);
});
//# sourceMappingURL=RTTI_ClaimResponse.js.map